import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTheme } from 'styled-components';
import Div from '../../common/div';
import Typography from '../../common/typography';
import { GrantCardInfosBoxBody, GrantCardInfosBoxContainer } from './styles';
const GrantCardBox = ({ label, Icon, bodyTheme, children, }) => {
    const theme = useTheme();
    return (_jsxs(GrantCardInfosBoxContainer, { children: [_jsxs(Div, { flex: "row", align: "center", gap: theme.appearance.spacing * 1, children: [_jsx(Icon, { size: bodyTheme.iconSize, color: theme.colors.grey_2 }), _jsx(Typography, { elementTheme: bodyTheme.labelSize, color: theme.colors.grey_2, nowrap: true, children: label })] }), _jsx(GrantCardInfosBoxBody, { children: _jsx(Typography, { elementTheme: bodyTheme.valueSize, textAlign: "left", style: { width: '100%' }, children: children }) })] }));
};
export default GrantCardBox;
